import module from './reset-password.module';
import './reset-password.controller';
import './reset-password.style.scss';

export default module.name;
